import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useAppDispatch } from '../../app/hooks';
import { updateVenueState } from '../../features/venue/venueSlice';
import PlacesSearch from './PlacesSearch';
import EditForm from './EditForm';
import { Location } from '../../graphql/types';
import { clearObj } from '../../lib/utils';
import { updateVenue } from '../../lib/apis/venue';
import { mapGeoapifyToLocation, updateLocation } from '../../lib/apis/location';
import styles from '../../styles/components/organisms/VenueLocationForm.module.scss';

interface VenueLocationFormProps {
  venueID?: string;
  serviceProviderID?: string;
  prefill?: Location;
  onSubmit?: (id?: string) => void;
  onCancel?: () => void;
}

const VenueLocationForm = (props: VenueLocationFormProps) => {
  const { t } = useTranslation(['common', 'venue']);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState() as any;
  const [fieldErrors, setFieldErrors] = useState([]) as any;
  const { venueID, prefill, onSubmit, onCancel } = props;
  const formID = 'locationForm';
  const { id, address } = (prefill as Location) || {};
  const { formatted } = address || {};

  /**
   * Handle errors
   */
  const handleError = (error: any, payload?: any) => {
    console.error(formID, error, payload);
    setError(error);
    setLoading(false);
  };

  // Update Location
  const updateBusinessLocation = (location_id: string, obj: any) => {
    const payload = mapGeoapifyToLocation(
      clearObj({
        ...obj,
        lng: obj.lon,
      })
    ) as any;

    try {
      // Save updated location to database and update current state.data
      updateLocation(location_id, payload).then((location: any) => {
        console.log('updateLocation', payload, location);
        const { country, city } = location.address;
        updateBusiness({
          ...obj,
          location,
          country,
          city,
        });
      });
    } catch (error) {
      handleError(error);
    }
  };

  // Update Venue
  const updateBusiness = (obj: any) => {
    //Reduce current data to expected payload fields
    const { location, country, city } = obj;
    const payload = clearObj({
      country,
      city,
    });

    if (venueID) {
      try {
        // Save to database and update venueState
        updateVenue(venueID, payload).then((venue) => {
          console.log('updateVenue', payload, venue);
          setLoading(false);
          dispatch(
            updateVenueState({
              ...venue,
              location,
            })
          );
          if (!!onSubmit) {
            onSubmit();
          }
        });
      } catch (error) {
        handleError(error, payload);
      }
    }
  };

  /**
   * Handle form submit
   */
  const submit = (formData: any) => {
    setError(false);
    setLoading(true);
    if (id) {
      updateBusinessLocation(id, formData);
    }
  };

  const cancel = () => {
    if (!!onCancel) {
      onCancel();
    }
  };

  return (
    <EditForm
      id={formID}
      className={styles.venueLocationForm}
      title={t('common:location')}
      error={error}
      loading={loading}
      onSubmit={submit}
      onCancel={cancel}
      onFieldError={(arr: any) => setFieldErrors(arr)}
    >
      <PlacesSearch withFields defaultValue={formatted} />
    </EditForm>
  );
};

export default VenueLocationForm;
